<p-table [columns]="columnLabels.peopleLabels" [value]="dataSource">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + company | lowercase">
      <th>{{ columnLabels.product }}</th>
      <th *ngFor="let label of columnLabels.peopleLabels">{{ label.header }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data let-columns="columns">
    <tr>
      <td>{{ data.name }}</td>
      <td *ngFor="let column of columns">
        {{ data.prices[column.band] | lxPrice : { defaultValue: '-' } }}
      </td>
    </tr>
  </ng-template>
</p-table>

<lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
